import { render, staticRenderFns } from "./YReplace.vue?vue&type=template&id=319c1460"
import script from "./YReplace.vue?vue&type=script&lang=js"
export * from "./YReplace.vue?vue&type=script&lang=js"
import style0 from "./YReplace.vue?vue&type=style&index=0&id=319c1460&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports